import React, { useState, useContext, useEffect } from "react";
import Application from "../../../StateContext/Application";

const AdminPassKeys = () => {
  const statecalls = useContext(Application);
  const { GetAdminPassKeys, AddAdminPassKeys, DeleteAdminPassKeys } = statecalls;
  const [adminpasskeys, setAdminPassKeys] = useState([]);
  const [adminpasskeysdata, setAdminPassKeysData] = useState({});
  useEffect(() => {
    AllAdminPassKeys();
  }, []);

  async function AllAdminPassKeys() {
    try {
      let data = await GetAdminPassKeys();
      setAdminPassKeys(data);
    } catch (error) {
      console.error(error);
    }
  }

  async function SetAdminPassKeys(e) {
    e.preventDefault()
    try {
      let data = await AddAdminPassKeys(adminpasskeysdata);
      AllAdminPassKeys();
      alert("AdminPassKeys Created Successfully")
    } catch (error) {
      console.error(error);
    }
  }

  async function RemoveAdminPassKeys(e,x) {
    
    console.log(e);
    x.preventDefault()
    try {
    
       let confirmmsg = window.confirm("Are you sure you want to delete this adminpasskey?");
       if (confirmmsg) {
        let data = await DeleteAdminPassKeys(e)
        alert("Admin Pass Key Deleted");
       } else {
        alert("Canceled Deletion.");
       }
        
    } catch (error) {
        console.error(error);
      }
  }

  return (
    <>
      <div>AdminPassKeys</div>
      <div style={{padding:"50px"}}>
        <form onSubmit={SetAdminPassKeys} style={{display:"grid"}}>
            <label className="form-label">Subject CN</label>
            <input className="form-control" id="SubjectCN" required placeholder="Enter SubjectCN Here" onChange={(e)=>setAdminPassKeysData({...adminpasskeysdata,[e.currentTarget.id]:e.target.value})}/>
            <label className="form-label">Thumb Print</label>
            <input className="form-control" id="Sha1Thumbprint" required placeholder="Enter Thumb Print Here" onChange={(e)=>{
                setAdminPassKeysData({...adminpasskeysdata,[e.currentTarget.id]:e.target.value})
            }}/>
            <label className="form-label">Serial Number</label>
            <input className="form-control" id="SerialNumber" required placeholder="Enter Serial Number Here" onChange={(e)=>{
                setAdminPassKeysData({...adminpasskeysdata,[e.currentTarget.id]:e.target.value})
            }}/>
            <button className="my-3 btn btn-success" style={{backgroundColor:"#e73d26",border:"none"}}>Add Admin Pass Keys</button>
        </form>
      </div>
      <div style={{ padding: "50px" }}>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Sr.no.</th>
              <th>Subjetc CN</th>
              <th>Thumb Print</th>
              <th>Serial Number</th>
            </tr>
          </thead>
          <tbody>
            {adminpasskeys &&
              adminpasskeys.map((e,index) => {
                return (
                  <tr key={index}>
                    <td>{index+1}</td>
                    <td>{e.SubjectCN}</td>
                    <td>{e.Sha1Thumbprint}</td>
                    <td>{e.SerialNumber}</td>
                    <td><button className="btn btn-danger" style={{backgroundColor:"#e73d26",border:"none"}} onClick={(x)=>RemoveAdminPassKeys(e,x)}>Delete</button></td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AdminPassKeys;
